module.exports = __webpack_public_path__ + "fonts/Raleway-Light.805618b8.ttf";